"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parenthesisExpression = ({ ast, execObject }) => {
    return execObject.interpreter({
        ast: ast.children.parentheses[0].children.rules[0],
        execObject,
    });
};
